import { Button, Flex, Modal } from 'antd'
import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { EditOutlined, LeftOutlined, PlusOutlined } from '@ant-design/icons'
import { FormInstance } from 'antd/lib'

export default function useShowStandardSuccessModal(title: ReactNode, form: FormInstance) {
    const navigate = useNavigate()

    return (settings: { listRoute: string; editingRoute: string }) => {
        const modal = Modal.success({
            title,
            content: (
                <Flex gap={12} wrap>
                    <Button
                        type={'primary'}
                        icon={<LeftOutlined />}
                        onClick={() => {
                            modal.destroy()
                            navigate(settings.listRoute)
                        }}
                    >
                        К списку
                    </Button>
                    <Button
                        icon={<PlusOutlined />}
                        onClick={() => {
                            modal.destroy()
                            form.resetFields()
                        }}
                    >
                        Создать новый
                    </Button>
                    <Button
                        icon={<EditOutlined />}
                        onClick={() => {
                            modal.destroy()
                            navigate(settings.editingRoute)
                        }}
                    >
                        Редактировать текущий
                    </Button>
                </Flex>
            ),
            footer: null,
        })
    }
}
